import React from 'react'
import EUI from '../../../addons/images/logotypes/EUI.png'
import lancester from '../../../addons/images/logotypes/lancester.png'
import jewish from '../../../addons/images/logotypes/jude.png'
import DCU from '../../../addons/images/logotypes/DCU.png'
import cultures from '../../../addons/images/logotypes/cultures.png'
import itti from '../../../addons/images/logotypes/itti.png'
import ceu from '../../../addons/images/logotypes/ceu.png'
import { Header, Image } from 'semantic-ui-react'
import { Link } from 'react-router'

const bravePartners = () => {
  return (
    <Link className='Section' to='/about/consortium'>
      <Header as='h2'>
    BRaVE partners
      </Header>
      <div style={{ display: 'flex', flexFlow: 'row wrap', justifyContent: 'space-around', alignItems: 'center' }}>
        <Image src={EUI} height={50} style={{ margin: 10 }}/>
        <Image src={lancester} height={50} style={{ margin: 10 }}/>
        <Image src={jewish} height={70} style={{ margin: 10 }}/>
        <Image src={DCU} height={60} style={{ margin: 10 }}/>
        <Image src={itti} height={50} style={{ margin: 10 }}/>
        <Image src={cultures} height={50} style={{ margin: 10 }}/>
        <Image src={ceu} height={50} style={{ margin: 10 }}/>
      </div>
    </Link>
    )
}

export default bravePartners



// WEBPACK FOOTER //
// ./src/components/HomeComponent/BravePartners/BravePartners.js